import {apiEndpoint, getAccessToken} from "./data";

export function getExportUrl(model: string, writer: 'xlsx', filterQueryString: string) {

    let q = filterQueryString.replace(/^\?/, '');

    return `${apiEndpoint}/export/${writer}/${model}` +
        `?token=${getAccessToken()}&${q}`;
}
